import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "Login" }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_telegram_login = _resolveComponent("vue-telegram-login")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user == null)
      ? (_openBlock(), _createBlock(_component_vue_telegram_login, {
          key: 0,
          mode: "callback",
          "telegram-login": _ctx.telegramBotName,
          onCallback: _ctx.callbackFunction,
          size: "small"
        }, null, 8, ["telegram-login", "onCallback"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(_ctx.getUserInfo()), 1)
        ]))
  ]))
}